import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BreadCrumb } from 'src/app/models/common/bread-crumb';
import { PageHeader } from 'src/app/models/common/page-header';
import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { CompensationService } from '../services/compensation.service';

@Component({
  selector: '',
  template: '',
})
export class EndorsementInquirySearchHandler extends BaseSearchComponent<CompensationService> implements OnInit {
  public searchName: string;

  constructor(
    public service: CompensationService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService
  ) {
    super(service, router, headerService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.searchName = 'SearchAgentEndorsement';
  }

  protected getBreadCrumbList(): BreadCrumb[] {
    return [
      {
        id: 'Home',
        link: '/home',
      },
      {
        id: 'Search',
      },
    ];
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    header.title = this.settingService.getLabelValue('modificationInProfile');
    return header;
  }

  ngOnDestroy(): void {}
}
